export const SectionNames = {
  BATCH: 'Proceso por lotes',
  INTEGRATIONS: 'Integraciones',
  CONFIGURATIONS: 'Configuraciones',
  USERS: 'Usuarios',
  NOTIFICATIONS: 'Notificaciones',
  EVENTS: 'Eventos',
  BILLING: 'Facturación'
};

export const TabItems = [
  { key: 'Mis datos', grants: ['CONFIGURATIONS', 'PROFILE'] },
  { key: 'Usuarios', grants: ['CONFIGURATIONS', 'USERS'] },
  { key: 'Notificaciones', grants: ['CONFIGURATIONS', 'NOTIFICATIONS'] },
  { key: 'Eventos', grants: ['CONFIGURATIONS', 'EVENTS'] },
  { key: 'Integraciones', grants: ['CONFIGURATIONS', 'INTEGRATIONS'] },
  { key: 'Facturación', grants: ['CONFIGURATIONS', 'BILLING'] },
  { key: 'Proceso por lotes', grants: ['CONFIGURATIONS', 'BATCH'] }
];
